export { default as attendanceDomain } from "./Attendance.domain";
